import { Directive, ElementRef, Inject, Input, OnInit } from '@angular/core';
import { THEME_TOKEN, Theme } from '../types/theme.types';
import { componentStylesByTheme } from '../utils/theme.utils';
import {
  chipStylesSAG,
  chipStylesSHS,
  chipStylesSelectedSAG,
  chipStylesSelectedSHS,
} from './chip.styles';
import { updateElementStyles } from '../utils/style.utils';

@Directive({
  selector: 'span[sag-ui-chip]',
})
export class ChipDirective implements OnInit {
  @Input() selected = false;

  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>,
  ) {}

  ngOnInit(): void {
    const styles = componentStylesByTheme(
      this.theme,
      chipStylesSAG,
      chipStylesSHS,
    );

    const selectedStyles = componentStylesByTheme(
      this.theme,
      chipStylesSelectedSAG,
      chipStylesSelectedSHS,
    );

    updateElementStyles(
      this.elementRef,
      this.selected ? selectedStyles() : styles(),
    );
  }
}
